import React, { Component } from 'react';
import './Partners.css';
import { Link } from 'react-router-dom';

class Partners extends Component {
    render() {
        return (
            <div className="partners">
                <p className="partners--intro">Ils me font confiance :</p>
                <div className="partners--list">
                    <Link to={`/partenaire/partenariat-youdoit`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/youdoit.png" alt="youdoit" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-mes-epices`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/mesepices.png" alt="mesepices" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-fackelmann`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/fackelmann.png" alt="fackelmann" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-fossier`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/maison_fossier.png" alt="fossier" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-ustensiles-et-cuisine`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/ustensiles_et_cuisine.png" alt="ustensiles_et_cuisine" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-autour-du-gateau`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/autour_du_gateau.png" alt="autour_du_gateau" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-manelli`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/manelli.png" alt="manelli" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-vetement-pro`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/vetement_pro.png" alt="vetement_pro" />
                        </a>
                    </Link>
                    <Link to={`/partenaire/partenariat-mon-emporte-piece`}>
                        <a className="partners-list__item">
                            <img className="partners-list__img" src="/images/partners/logos/monemportepiece.jpg" alt="monemportepiece" />
                        </a>
                    </Link>
                </div>
            </div>
        );
    }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/components/Partners.js